import { API_BASE_URL, API_PATHS, } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ProjectService {

    static getProject(item) {

        let api = `${API_BASE_URL}${API_PATHS.getProject}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static getSite(item) {

        let api = `${API_BASE_URL}${API_PATHS.getSite}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.projectId) params.append("projectId", item.projectId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addProject(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addProject}`;
        return axiosInstance
            .post(api, data)

    }

    static addSite(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addSite}`;
        return axiosInstance
            .post(api, data)

    }

    static editProject(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editProject}`;
        return axiosInstance
            .put(api, data)

    }

    static editSite(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editSite}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteProject(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.projectDelete}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


    static deleteSite(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteSite}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default ProjectService;
